const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  isZh: state => state.app.isZh,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  menus: state => state.user.menus,
  tenantId: state => state.user.tenantId,
  currentUser: state => state.user.currentUser,
  currentTenantName: state => state.user.currentTenantName,
  currentTenantType: state => state.user.currentTenantType,
  currentProjectName: state => state.org.currentProjectName,
  currentProjectId: state => state.org.currentProjectId,
  currentProjectList: state => state.org.currentProjectList,
  overviewArr: state => state.overview.overviewArr,
  permission_routes: state => state.permission.routes

}
export default getters
